import { useAppSelector } from '@/hooks';
import { Icons } from '@/utils/Icons';
import React, { useEffect, useRef } from 'react';
import { FaHome, FaBook, FaWallet, FaMoneyBillWave } from 'react-icons/fa';
import { GiReceiveMoney } from 'react-icons/gi';
import { useNavigate } from 'react-router-dom';
import { useUserInfo } from '@/hooks/useUserInfo';

export default function RadialMenu({ open, setOpen }: any) {
  const radius = 80;
  const navigate = useNavigate();
  const menuRef = useRef<HTMLDivElement>(null);

  const { supportInfo } = useAppSelector((state) => state.user);

  const whatsappLink = supportInfo?.whatsapp ?? '#';
  const { userId } = useUserInfo();

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('click', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [open]);

  const menuItems = [
    { icon: Icons.Whatsapp, label: 'Talk to us?', path: whatsappLink, external: true },
    { icon: FaHome, label: 'Home', path: '/' },
    { icon: GiReceiveMoney, label: 'Referrals', path: '/referrals' },
    { icon: FaBook, label: 'Bets', path: userId ? '/bet-history' : '?mode=login' },
    { icon: FaWallet, label: 'Deposit', path: '/deposit' },
    { icon: FaMoneyBillWave, label: 'Withdraw', path: '/withdraw' },
  ];

  const handleClick = (item: any) => {
    if (item.external) {
      window.open(item.path, '_blank');
    } else {
      navigate(item.path);
    }

    setOpen(false);
  };

  return (
    <>
      {open && <div className="fixed inset-0 z-[6500] bg-black/30 backdrop-blur-[1px]" />}

      <div
        ref={menuRef}
        className={`fixed bottom-[60px] left-1/2 z-[7000] -translate-x-1/2 transition-all duration-500 ${
          open
            ? 'opacity-100 scale-100 pointer-events-auto'
            : 'opacity-0 scale-[0.1] pointer-events-none'
        }`}
      >
        <div
          className={`relative w-[240px] h-[240px] rounded-full 
          bg-[rgba(26,26,26,0.5)] 
          border-[3px] border-primary
          shadow-[inset_0_0_20px_2px_#0b1628]
          backdrop-blur-[2px]
          transition-all duration-500 ease-out
          ${open ? 'rotate-0' : 'rotate-[-270deg]'}`}
        >
          {menuItems.map((item, i) => {
            const angle = (i / menuItems.length) * 2 * Math.PI - Math.PI / 2;

            const x = Math.cos(angle) * radius;
            // const y = Math.sin(angle) * radius;
            const y = Math.sin(angle) * radius - (i === menuItems.length - 3 ? 24 : 0);
            const Icon = item.icon;

            return (
              <div
                key={i}
                onClick={() => handleClick(item)}
                className="absolute flex flex-col items-center cursor-pointer transition-all duration-500"
                style={{
                  left: `calc(50% + ${x}px)`,
                  top: `calc(50% + ${y}px)`,
                  transform: 'translate(-50%, -50%)',
                }}
              >
                <div
                  className="
                    size-[35px]
                    rounded-full
                    flex items-center justify-center
                    bg-yellow-400
                    shadow-lg
                    transition-all duration-300
                    hover:scale-110
                    active:scale-95
                  "
                >
                  <Icon className="text-black text-[22px]" />
                </div>

                <span className="mt-1 text-[10px] text-white whitespace-nowrap">{item.label}</span>
              </div>
            );
          })}

          {/* <div className="absolute inset-[70px] rounded-full bg-[#1f2324]" /> */}
        </div>
      </div>
    </>
  );
}
